import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import ReactPlayerLoader from "@brightcove/react-player-loader";

const VideoPlayer = ({ width, height }) => {
  let videoRef = React.createRef();
  console.log(videoRef);
  const [play, changePlay] = useState(false);
  useEffect(() => {
    if (play === true) {
      videoRef.current.play();
    }
  }, [play, videoRef]);

  const renderButton = () => {
    if (!play) {
      return (
        <Button variant="dark" onClick={() => changePlay(true)}>
          Play
        </Button>
      );
    }
  };

  // const videoUrl =
  //   "https://players.brightcove.net/78527773001/46a5f41d-f0b0-4a4b-af32-b9e4c070c08a_default/index.html?videoId=6111141369001";
  // return <ReactPlayer url={videoUrl} height={height} width={width} />;
  return (
    <div>
      <ReactPlayerLoader
        playerId="NrtqkDxxj"
        embedId="default"
        accountId="78527773001"
        videoId="6111141369001"
        attrs={{ className: "vjs-fluid" }}
      />
    </div>
  );
};

export default VideoPlayer;
